import React from 'react';
import { motion } from 'framer-motion';
import { Timer, Star, ShieldCheck, Zap, CreditCard } from 'lucide-react';
import { useCountdown } from '../hooks/useCountdown';
export function HeroSection() {
  const {
    hours,
    minutes,
    seconds
  } = useCountdown();
  const scrollToOffer = () => {
    const offerSection = document.getElementById('oferta');
    if (offerSection) {
      offerSection.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <section className="relative bg-[#0A0A0A] text-white min-h-screen flex flex-col pt-16" data-id="element-149">
      {/* Sticky Urgency Bar */}
      <div className="fixed top-0 left-0 right-0 bg-red-600 text-white py-2 z-50 shadow-lg" data-id="element-150">
        <div className="container mx-auto px-4 flex flex-col sm:flex-row items-center justify-center gap-2 text-sm font-bold text-center" data-id="element-151">
          <span className="flex items-center gap-1" data-id="element-152">
            <Zap className="w-4 h-4" data-id="element-153" /> PRECIO ESPECIAL POR TIEMPO LIMITADO —
            QUEDAN SOLO 24HS <Zap className="w-4 h-4" data-id="element-154" />
          </span>
          <div className="flex items-center gap-1 bg-black/20 px-3 py-1 rounded-md" data-id="element-155">
            <Timer className="w-4 h-4" data-id="element-156" />
            <span data-id="element-157">
              {hours.toString().padStart(2, '0')}:
              {minutes.toString().padStart(2, '0')}:
              {seconds.toString().padStart(2, '0')}
            </span>
          </div>
        </div>
      </div>

      <div className="container mx-auto px-4 py-12 flex-grow flex flex-col items-center justify-center text-center" data-id="element-158">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.4
      }} className="max-w-4xl mx-auto" data-id="element-159">
          <h2 className="text-[#D4A017] font-bold tracking-wider text-sm md:text-base mb-4 uppercase" data-id="element-160">
            SUPER COMBO CARPINTERÍA EN ALUMINIO
          </h2>

          <h1 className="text-4xl md:text-5xl lg:text-6xl font-extrabold leading-tight mb-6" data-id="element-161">
            El Sistema Completo Para Fabricar, Presupuestar y Cobrar Más en
            Líneas Herrero, Módena y A30
          </h1>

          <p className="text-[#D4A017] text-lg md:text-xl font-medium mb-10 max-w-3xl mx-auto" data-id="element-162">
            Sin desperdiciar perfiles. Sin presupuestos que no cierran. Sin
            clientes que te dejan en visto.
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.4,
        delay: 0.2
      }} className="relative w-full max-w-2xl mx-auto mb-12" data-id="element-163">
          <div className="absolute inset-0 bg-[#D4A017]/20 blur-3xl rounded-full" data-id="element-164"></div>
          <div className="relative" data-id="element-165">
            <img src="https://cdn.magicpatterns.com/uploads/cfrr59dH9UgqjLtnooiWHb/private_openrouter-generated-image-1776383681366.png" alt="Super Combo Carpintería en Aluminio PRO — 6 Tomos + 6 Bonos" className="w-full h-auto object-contain drop-shadow-[0_0_30px_rgba(212,160,23,0.3)]" data-id="element-166" />
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.4,
        delay: 0.4
      }} className="w-full max-w-md mx-auto flex flex-col items-center" data-id="element-167">
          <button onClick={scrollToOffer} className="w-full bg-[#D4A017] hover:bg-[#b58812] text-black font-black text-xl py-5 px-8 rounded-xl shadow-[0_0_20px_rgba(212,160,23,0.4)] transition-all transform hover:scale-105 flex items-center justify-center gap-2 mb-6" data-id="element-168">
            🔥 QUIERO EL SISTEMA COMPLETO →
          </button>

          <div className="flex items-center gap-2 mb-8" data-id="element-169">
            <div className="flex text-[#D4A017]" data-id="element-170">
              {[...Array(5)].map((_, i) => <Star key={i} className="w-5 h-5 fill-current" data-id="element-171" />)}
            </div>
            <span className="text-gray-300 font-medium text-sm" data-id="element-172">
              +1.200 carpinteros ya lo usan en Argentina
            </span>
          </div>

          <div className="flex flex-wrap justify-center gap-4 md:gap-6 text-gray-400 text-sm font-medium" data-id="element-173">
            <div className="flex items-center gap-1" data-id="element-174">
              <ShieldCheck className="w-4 h-4 text-[#D4A017]" data-id="element-175" />
              <span data-id="element-176">Garantía 7 días</span>
            </div>
            <div className="flex items-center gap-1" data-id="element-177">
              <Zap className="w-4 h-4 text-[#D4A017]" data-id="element-178" />
              <span data-id="element-179">Acceso inmediato</span>
            </div>
            <div className="flex items-center gap-1" data-id="element-180">
              <CreditCard className="w-4 h-4 text-[#D4A017]" data-id="element-181" />
              <span data-id="element-182">Mercado Pago</span>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}